<template>
  <div class="ap-invoice-title">
    <div class="invoice-title-list" v-show="!$route.params.id">
      <div style="height: 56px;">
        <div class="title float-left">发票抬头管理</div>
        <button class="ap-btn-red ap-btn-red-hover1 float-right" @click="showDialog()">新建发票抬头</button>
      </div>
      <div>
        <table style="cursor:pointer" class="table table-hover font12">
          <thead>
            <tr>
              <th>发票抬头</th>
              <th>纳税识别号</th>
              <th>开户银行与账号</th>
              <th>地址与电话</th>
              <th style="width:120px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="it in invoiceInfos" :key="it.idx">
              <td>{{it.title}}</td>
              <td>{{it.taxNumber}}</td>
              <td>{{it.bankName}} {{it.bankAccount}}</td>
              <td>{{it.bankAddress}} {{it.bankPhoneNumber}}</td>
              <td class="text-center">
                <a class="btn btn-sm btn-icon btn-secondary" @click="showDialog(it)">
                  <i class="fa fa-pencil-alt"></i>
                  <span class="sr-only">Edit</span>
                </a>
                <a class="btn btn-sm btn-icon btn-secondary" @click="remove(it.idx)" style="margin-left:10px">
                  <i class="far fa-trash-alt"></i>
                  <span class="sr-only">Remove</span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Dialog v-if="showCreateDialog" title="新建发票抬头" class="dialog" @callback="save" ref="dialog">
      <div class="dialog-item">
        <strong class="name">发票抬头</strong>
        <input class="form-control" v-model="title" />
      </div>
      <div class="dialog-item">
        <strong class="name">纳税识别号</strong>
        <input class="form-control" v-model="taxNumber" />
      </div>
      <div class="dialog-item">
        <strong class="name">开户银行</strong>
        <input class="form-control" v-model="bankName" />
      </div>
      <div class="dialog-item">
        <strong class="name">银行账号</strong>
        <input class="form-control" v-model="bankAccount" />
      </div>
      <div class="dialog-item">
        <strong class="name">地址</strong>
        <input class="form-control" v-model="bankAddress" />
      </div>
      <div class="dialog-item">
        <strong class="name">电话</strong>
        <input class="form-control" v-model="bankPhoneNumber" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "@components/Dialog.vue";

export default {
  components: {
    Dialog
  },
  data() {
    return {
      showCreateDialog: false,
      invoiceInfos: [],
      title: "",
      taxNumber: "",
      bankName: "",
      bankAccount: "",
      bankAddress: "",
      bankPhoneNumber: "",
      invIdx: -1
    };
  },
  created() {
    this.getOrgPro();
    document.title = "51 AUTOPARTS 发票抬头管理";
  },
  methods: {
    getOrgPro() {
      this.$get("/spms/myProfiles/getOrgProfile/")
        .then(res => (this.invoiceInfos = res.invoiceInfos))
        .catch(err => {});
    },
    showDialog(item) {
      if (item) {
        this.title = item.title;
        this.taxNumber = item.taxNumber;
        this.bankName = item.bankName;
        this.bankAccount = item.bankAccount;
        this.bankAddress = item.bankAddress;
        this.bankPhoneNumber = item.bankPhoneNumber;
        this.invIdx = item.idx;
      } else {
        this.title = "";
        this.taxNumber = "";
        this.bankName = "";
        this.bankAccount = "";
        this.bankAddress = "";
        this.bankPhoneNumber = "";
        this.invIdx = -1;
      }
      this.showCreateDialog = true;
      if (!this.$refs.dialog) return;
      this.$refs.dialog.show();
    },
    save() {
      if (!this.title) return $msg.warning("请填写发票抬头！");
      if (!this.taxNumber) return $msg.warning("请填写纳税识别号！");
      if (!this.bankName) return $msg.warning("请填写开户银行！");
      if (!this.bankAccount) return $msg.warning("请填写银行账号！");
      let args = {
        title: this.title,
        taxNumber: this.taxNumber,
        bankAccount: this.bankAccount,
        bankName: this.bankName,
        bankAddress: this.bankAddress,
        bankPhoneNumber: this.bankPhoneNumber
      };
      if (this.invIdx >= 0) args.idx = this.invIdx;
      this.$post("/spms/myProfiles/saveOrgInvo", args)
        .then(res => {
          this.getOrgPro();
          this.$refs.dialog.close();
        })
        .catch(err => {});
    },
    remove(idx) {
      $alert({
        type: "remove",
        title: "确定删除吗？",
        text: "一旦删除将无法恢复，请确定是否继续。",
        ok: () => {
          this.$post("/spms/myProfiles/removeOrgInvo/", { idx })
            .then(res => this.getOrgPro())
            .catch(err => {});
        }
      });
    }
  }
};
</script>

<style lang="less">
.ap-invoice-title {
  .dialog-item {
    display: flex;
    padding: 15px;
    .name {
      width: 110px;
      line-height: 36px;
    }
  }
  padding: 20px;
  background: #fff;
  .title {
    margin-bottom: 20px;
    font-size: 24px;
  }
  .invoice-title-list {
    .table {
      tbody {
        color: #666;
      }
    }
    .col1 {
      width: 306px;
      span,
      a {
        display: inline-block;
        vertical-align: top;
      }
      span + span {
        margin-left: 25px;
      }
      a {
        margin-left: 5px;
        width: 100px;
        color: #09c;
        text-align: left;
        &:hover {
          color: #09c;
          text-decoration: underline;
        }
      }
    }
    .col3 {
      width: 150px;
    }
    .col4 {
      width: 114px;
    }
    .col5 {
      width: 126px;
      button {
        padding-top: 2px !important;
        padding-bottom: 2px !important;
      }
    }
  }
}
</style>